module.exports = __webpack_public_path__ + "static/img/LogoImperial.f5a4855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/LogoImperial.jpg
// module id = FjcR
// module chunks = 23